export const iconFontAwesomeMusicVideoCompactDisc = (
	<i className="fa-solid fa-compact-disc"></i>
);
